import { TemplateRef } from "@angular/core";

export class NavTab {
    tabIndex: number;
    // Tab label translation 
    name: string;
    active?: boolean;
    tabTemplate: TemplateRef<any>;
    tabWidth?: number;
    disabled?: () => boolean;
    valid?: () => boolean;
}